export function parseTime(date: Date | undefined): string {
  if (!date) return "";
  const d = new Date(date);
  if (isNaN(d.getTime())) return "";
  const locale = navigator.language || "en-US";
  const now = new Date();
  const time = d.toLocaleTimeString(locale, { hour: "numeric", minute: "2-digit", hour12: true });
  const isToday = d.getFullYear() === now.getFullYear() && d.getMonth() === now.getMonth() && d.getDate() === now.getDate();
  if (isToday) return time;
  const datePart = d.toLocaleDateString(locale, {
    month: "short",
    day: "numeric",
    ...(d.getFullYear() !== now.getFullYear() ? { year: "numeric" } : {})
  });
  // Comma, matching the transcript bubbles and date dividers (PROD-773).
  return `${datePart}, ${time}`;
}
